export enum WorkflowRunMode {
    StepByStep = 'StepByStep',
    SingleAndBatchRun = 'SingleAndBatchRun',
}
